import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { buildOptions } from "../Options"
import { ListingProps } from "../Listing"
import ListingResults from "../ListingResults"
import ListingFilter from "../ListingFilter"

import { useLocale } from "../../../context/LocaleContext"
import { getUrlStructure } from "../../../utils"
import { PageModel, PageModels } from "../../../models/pages"

const defaultProps = {}

type ArticleListingModel = {
  items?: PageModels[]
  categories?: string[]
}

interface Props extends ListingProps {
  pageContext: any
}
export const PageListing: React.FC<Props> = props => {
  // context
  const locale = props.pageContext.locale

  // graphQL
  const query = useStaticQuery(graphql`
    query {
      items: allContentstackPage(filter: { title: { ne: "do not delete" } }) {
        nodes {
          ...ContentPageFields
        }
      }
    }
  `)

  // state
  const [listing, setListing] = useState<ArticleListingModel>({})

  useEffect(() => {
    if (query) {
      // filter for locale
      let pages: PageModel[] = query.items.nodes.filter(
        (x: PageModel) => x.publish_details.locale === locale
      )

      // filter articles by root page
      const root = !!props.root_page?.length ? props.root_page[0] : undefined
      if (root) {
        if (props.display_all_children) {
          pages = pages.filter(page => {
            return getUrlStructure(page.url_structure)
              .map(x => x.id)
              .includes(root.id)
          })
        } else {
          pages = pages.filter(page => {
            return (
              getUrlStructure(page.url_structure)
                .map(x => x.id)
                .at(-1) === root.id
            )
          })
        }
      }

      // filter articles to remove selected items
      const listing_items = props.listing_items || []
      if (listing_items.length) {
        const selected = listing_items.map(x => x.id)
        pages = pages.filter(article => !selected.includes(article.id))
      }

      // all listing pages
      const allPages = [...listing_items, ...pages]

      // save listing
      setListing({
        items: allPages,
        categories: [],
      })
    }
  }, [query, locale, props.root_page, props.listing_items])

  return (
    <section className="listing articleListing">
      {listing.categories && (
        <ListingFilter
          categoryOptions={buildOptions(listing.categories)}
          pageContext={props.pageContext}
        />
      )}
      {listing.items && (
        <ListingResults
          items={listing.items}
          hasSidebar={props.hasSidebar}
          pageListing
          pageContext={props.pageContext}
        />
      )}
    </section>
  )
}

PageListing.defaultProps = defaultProps

export default PageListing
